import type { ProductVariantOptionImagePattern, Multipack } from './types/index'

export const POPUP_PRESENTS_ID = 'sb-popup-cart-presents'

export const ANY_VARIANT_OPTION_IMAGE_REGEX_WITH_INDEX: ProductVariantOptionImagePattern =
  {
    regex: new RegExp(`-(any)`, 'i'),
    regexWithIndex: new RegExp(`-(any)-(\\d+)`, 'i'),
  }

export const MARKETS: string[] = ['ALL', 'DE', 'AT', 'CH', 'INT', 'FR']

/**
 * Default counts of items in a multipack and the discount
 */
export const DEFAULT_MULTIPACK: Multipack = {
  quantity: 1,
  percentage: 0,
  active: true,
}

export enum VALIDATE_QUANTITY_ERROR {
  LessThanMin = 'lessThanMin',
  MoreThanMax = 'moreThanMax',
}

/**
 * Historically window.Shopify.country was used to determine the market. However this isn't correct as some markets encompass multiple countries. It's also not usable
 * for our international market because we currently use the identifier `INT` for it which is no valid country code.
 * Because moving away from Shopify.country is a bigger task we use the following mapping table to map market handles from liquid:`localization.market.handle` to our legacy identifiers.
 * In the future a clean solution would use clean market handles in all places. The market handles could also be the legacy identifiers.
 * Reference: #65919
 */
export const marketHandleMap: Record<string, string | undefined> = {
  international: 'INT',
}
